import { useState, useEffect } from 'react';
import { api } from '../api/client';

const C = {
  bg: '#050510',
  surface: '#0d0d1f',
  border: 'rgba(255,255,255,0.06)',
  orange: '#f97316',
  purple: '#7c6ff7',
};

export default function ContactPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => { document.title = 'Contact — StartupScore'; }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim() || !email.trim() || !message.trim()) return;
    setStatus('sending');
    try {
      await api.post('/contact', { name: name.trim(), email: email.trim(), message: message.trim() });
      setStatus('success');
      setName(''); setEmail(''); setMessage('');
    } catch (err: any) {
      setStatus('error');
      setErrorMsg(err.response?.data?.error?.message || 'Something went wrong. Please try again.');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: C.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ maxWidth: 520, width: '100%' }}>
        <h1 style={{ fontSize: 32, fontWeight: 800, color: '#fff', marginBottom: 8, textAlign: 'center' }}>Get in Touch</h1>
        <p style={{ color: '#6b7280', fontSize: 15, textAlign: 'center', marginBottom: 32 }}>
          Questions, feedback, or partnership ideas? We'd love to hear from you.
        </p>

        {status === 'success' ? (
          <div style={{
            background: 'rgba(34,197,94,0.1)', border: '1px solid rgba(34,197,94,0.3)',
            borderRadius: 16, padding: '32px 24px', textAlign: 'center',
          }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>✓</div>
            <h2 style={{ color: '#22c55e', fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Message Sent!</h2>
            <p style={{ color: '#6b7280', fontSize: 14 }}>We'll get back to you as soon as possible.</p>
            <button
              onClick={() => setStatus('idle')}
              style={{
                marginTop: 20, padding: '10px 24px', borderRadius: 10,
                background: 'rgba(255,255,255,0.06)', border: `1px solid ${C.border}`,
                color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer',
              }}
            >
              Send another message
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{
            background: C.surface, border: `1px solid ${C.border}`,
            borderRadius: 20, padding: '32px 28px',
          }}>
            <label style={{ display: 'block', marginBottom: 16 }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: '#9ca3af', display: 'block', marginBottom: 6 }}>Name</span>
              <input
                type="text" value={name} onChange={e => setName(e.target.value)} required maxLength={100}
                style={{
                  width: '100%', padding: '10px 14px', borderRadius: 10,
                  background: 'rgba(255,255,255,0.04)', border: `1px solid ${C.border}`,
                  color: '#fff', fontSize: 14, outline: 'none',
                }}
              />
            </label>
            <label style={{ display: 'block', marginBottom: 16 }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: '#9ca3af', display: 'block', marginBottom: 6 }}>Email</span>
              <input
                type="email" value={email} onChange={e => setEmail(e.target.value)} required
                style={{
                  width: '100%', padding: '10px 14px', borderRadius: 10,
                  background: 'rgba(255,255,255,0.04)', border: `1px solid ${C.border}`,
                  color: '#fff', fontSize: 14, outline: 'none',
                }}
              />
            </label>
            <label style={{ display: 'block', marginBottom: 20 }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: '#9ca3af', display: 'block', marginBottom: 6 }}>Message</span>
              <textarea
                value={message} onChange={e => setMessage(e.target.value)} required rows={5} maxLength={5000}
                style={{
                  width: '100%', padding: '10px 14px', borderRadius: 10,
                  background: 'rgba(255,255,255,0.04)', border: `1px solid ${C.border}`,
                  color: '#fff', fontSize: 14, outline: 'none', resize: 'vertical',
                }}
              />
            </label>
            {status === 'error' && (
              <div style={{ color: '#ef4444', fontSize: 13, marginBottom: 12 }}>{errorMsg}</div>
            )}
            <button
              type="submit" disabled={status === 'sending'}
              style={{
                width: '100%', padding: '12px 0', borderRadius: 12,
                background: C.orange, border: 'none',
                color: '#fff', fontSize: 15, fontWeight: 700, cursor: 'pointer',
                opacity: status === 'sending' ? 0.6 : 1,
              }}
            >
              {status === 'sending' ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
